import { RolesEnum } from '@goldcast/api/backend';

export const enum FilterBy {
  AllWorkspaces,
  MyWorkspaces
}

export const filterByItems = [
  {
    id: FilterBy.AllWorkspaces,
    title: 'All Team Workspaces'
  },
  {
    id: FilterBy.MyWorkspaces,
    title: 'My Team Workspaces'
  }
];

export enum UserRole {
  ORG_ADMIN = 'ORG_ADMIN',
  WORKSPACE_ADMIN = 'WORKSPACE_ADMIN',
  FLEXI_ADMIN = 'FLEXI_ADMIN'
}

export const rolesWithWorkspaceAccess: RolesEnum[] = ['Team Admin', 'Event Admin', 'Event Editor'];

export const rolesWithAllWorkspacesAccess: RolesEnum[] = [
  'Organization Admin',
  'Brand Editor',
  'Integrations Editor',
  'Content Lab Editor'
];

export const userRoleMap: Partial<Record<UserRole, string>> = {
  WORKSPACE_ADMIN: 'Team Admin',
  ORG_ADMIN: 'Organization Admin'
};
